import { connect } from "react-redux";

var CurrentUser = require("lib/account/CurrentUser");
var ZPDRange = require("lib/academic/ZPDRange");
var ReactTooltip = require("react-tooltip");
var ReadingLevelFormat = require("lib/academic/ReadingLevelFormat");

require("reading/reading_level_icon.scss");


class ReadingLevelIcon extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { }
	}
	getIconType() {
		if (this.props.status) {
			return this.props.status;
		}
		var status = ZPDRange.getTextStatus(
			this.props.textReadingLevel, this.props.studentReadingLevel
		);

		return ICON_TYPE_MAP[status];
	}
	getReadingLevelIcon() {
		var status = this.getIconType();
		return dynamicRequire("reading/reading-levels/" + status + ".png");
	}

	getFormattedReadingLevel() {
		var readingLevelFormat = CurrentUser.get().prefs.reading_level_format;
		return ReadingLevelFormat.getScoreForFormat(this.props.textReadingLevel, readingLevelFormat);
	}
	
	render() {
		var tooltipType = this.props.tooltipCopyType;
		var status = this.getIconType();
		if (!this.props.showImageOnly) {
			var divider = (
				<span className="verticalDivider"></span>
			)
			if (CurrentUser.isAdmin()) {
				var readingLevelValue = this.getFormattedReadingLevel();
			}
		}
		if (tooltipType == ReadingLevelIcon.COLLECTIVE_VIEW) {
			if (status == ReadingLevelIcon.HARD) {
				var tooltipText = "Books above reading level.";
			} else if (status == ReadingLevelIcon.ON_LEVEL) {
				var tooltipText = "Books at reading level.";
			} else {
				var tooltipText = "Books below reading level.";
			}

		} else if (tooltipType == ReadingLevelIcon.STUDENT_VIEW) {
			if (status == ReadingLevelIcon.HARD) {
				var tooltipText = "This book might be a challenge for you.";
			} else if (status == ReadingLevelIcon.ON_LEVEL) {
				var tooltipText = "This book is just right for you.";
			} else {
				var tooltipText = "This book might be too easy for you.";
			}
		} else {
			if (status == ReadingLevelIcon.HARD) {
				var tooltipText = "This book is above the student's reading level.";
			} else if (status == ReadingLevelIcon.ON_LEVEL) {
				var tooltipText = "This book is at the student's reading level.";
			} else {
				var tooltipText = "This book is below the student's reading level.";
			}
		}
		return (
			<div className="readingLevelContainer">
				{ divider }
				{ readingLevelValue }
				<img className="readingLevelImg" src={  this.getReadingLevelIcon() } alt="" data-tip={ tooltipText } />
				<ReactTooltip effect="solid" wrapper="span" />
			</div>
		)
	}
}

ReadingLevelIcon.propTypes = StrictPropTypes({
	studentReadingLevel: PropTypes.number,
	textReadingLevel: PropTypes.number,
	tooltipCopyType: PropTypes.string,
	showImageOnly: PropTypes.bool,

	// Forces the component to use this status
	status: PropTypes.string,	
});


ReadingLevelIcon.EASY = "easy";
ReadingLevelIcon.ON_LEVEL = "onlevel";
ReadingLevelIcon.HARD = "hard";

var ICON_TYPE_MAP = {
	[ZPDRange.UNDER]: ReadingLevelIcon.EASY,
	[ZPDRange.OVER]: ReadingLevelIcon.HARD,
	[ZPDRange.AT]: ReadingLevelIcon.ON_LEVEL
}

ReadingLevelIcon.COLLECTIVE_VIEW = "collective-view";
ReadingLevelIcon.TEACHER_VIEW = "teacher-view";
ReadingLevelIcon.STUDENT_VIEW = "student-view";

module.exports = ReadingLevelIcon;


// WEBPACK FOOTER //
// ./modules/components/reading/reading_levels/ReadingLevelIcon.js